import {exhibitorApplicationShows} from './exhibitorShows';
import {liveWindowOpen} from './video';

// Public show copy is separate from broadcast controls. Legacy free-text dates
// are not a confirmed schedule; only a future server-provided opening is shown.
export function showPresentation(exhibition) {
  const profile = exhibitorApplicationShows([exhibition])[0];
  const now = Date.now();
  const serverNow = exhibition.server_time != null
    ? exhibition.server_time * 1000 + now - (exhibition.live_received_at || now) : now;
  const opening = Number(exhibition.next_open_at) * 1000;
  // Only the server's validated schedule can establish completion.
  // A legacy stored status alone does not mean dates were finalized.
  const completed = exhibition.live_schedule_state === 'EXHIBITION_COMPLETED';
  return {
    title: profile?.name || exhibition.short || exhibition.name,
    status: liveWindowOpen(exhibition) ? 'Show Open' : completed ? 'Show Completed' : 'Upcoming Show',
    schedule: Number.isFinite(opening) && opening > serverNow
      ? new Date(opening).toLocaleString(undefined, {timeZoneName: 'short'})
      : completed ? 'This show has concluded' : 'Schedule Announcing Soon',
  };
}

export function ShowStatus({exhibition}) {
  return <span className="show-status" role="status">{showPresentation(exhibition).status}</span>;
}
